module.exports = __webpack_public_path__ + "img/hacienda-room-3.4cfbeb10.jpg";